module.exports = __webpack_public_path__ + "img/caseBuilder-dataAnalyst.fd91d45e.webp";